import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'answer-note',
  templateUrl: './answer-note.component.html',
  styleUrls: ['./answer-note.component.scss']
})
export class AnswerNoteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
